<template>
    <div v-tooltip="{content: validationInfo.tooltip, html: true}"
         class="font-12 mt-1"
         :class="validationLevelMeta.classes.text">
        {{ validationInfo.message }}
    </div>
</template>

<script>
import {
    getFieldValidationInfo,
    getFieldValidationLevelMeta
} from '../../../../../types/document-viewer/field/modules/validation'

export default {
    name: 'FieldValidationMessage',
    props: {
        validation: { // FieldValidation
            type: Object,
            required: false
        }
    },
    computed: {
        validationLevelMeta() {
            return getFieldValidationLevelMeta(this.validation.level)
        },

        validationInfo() {
            return getFieldValidationInfo({key: this.validation.key, params: this.validation.params})
        }
    }
}
</script>
